<template>
	<div class="news-container">
		<h1>{{ $t('homenews.title') }}</h1>

		<div class="news-list">
			<div class="news-item" v-for="(item, index) in newsList" :key="index" @click="gotoDetail(item)">
				<div class="news-content">
					<h4>{{ item.title }}</h4>
					<p>{{ item.description }}</p>
				</div>
				<div class="news-image">
					<img :src="item.image" :alt="item.title" />
				</div>
			</div>
		</div>

		<div class="view-more">
			<button class="view-more-btn" @click="gotoNews()">{{ $t('homenews.viewMore') }}</button>
		</div>
	</div>
</template>

<script>
import { homeNewsApi, baseImgUrl } from '../netTool/api';

export default {
	name: 'NewsSection',
	data() {
		return {
			newsList: []
		};
	},
	mounted() {
		this.loadNewsList();
	},
	methods: {
		async loadNewsList() {
			try {
				const response = await homeNewsApi.getAllHomeNews();
				if (response.success) {
					this.newsList = response.data.map((item) => ({
						title: item.title,
						description: item.subtitle,
						image: baseImgUrl + item.title_image_url,
						id: item.news_id
					}));
				}
			} catch (error) {
				console.error('加载新闻失败:', error);
			}
		},
		gotoNews() {
			this.$router.push('/news');
		},
		gotoDetail(news) {
			this.$router.push(`/newsDetail/${news.id}`);
		}
	}
};
</script>

<style scoped>
.news-container {
	padding: 40px 20px;
	max-width: 1200px;
	margin: 0 auto;
}

h1 {
	font-size: 2.5rem;
	color: #333;
	text-align: center;
	margin-bottom: 40px;
}

.news-list {
	display: flex;
	flex-direction: column;
}

.news-item {
	display: grid;
	grid-template-columns: 3fr 1fr;
	overflow: hidden;

	padding-top: 13px;
	padding-bottom: 15px;
	border-top: 1px solid #ececec;
	transition: all 0.3s ease;
}

.news-item :hover {
	cursor: pointer;
	transform: translateY(-2px);
}

.news-content {
	display: grid;
	grid-template-columns: 1fr 2fr;
}

.news-content h4 {
	color: #333;
}

.news-content p {
	color: #666;
}

.news-image {
	border-radius: 5px;
	width: 100%;
	aspect-ratio: 320/142;
	overflow: hidden;
}

.news-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.view-more {
	text-align: center;
	margin-top: 40px;
}

.view-more-btn {
	padding: 12px 30px;
	color: #000;
	border: 1px solid #000;
	border-radius: 30px;
	cursor: pointer;
	transition: all 0.3s ease;
	background: #fff;
}

.view-more-btn:hover {
	background: #f5f5f5;
	transform: translateY(-2px);
}

@media (max-width: 768px) {
	.news-item {
		grid-template-columns: 1fr; /* 改为 1 列布局 */
		padding: 15px 0; /* 调整内边距 */
	}

	.news-content {
		grid-template-columns: 1fr; /* 文字部分也改为 1 列 */
		margin-bottom: 12px; /* 图片和文字间距 */
	}

	.news-image {
		width: 100%; /* 图片宽度 100% */
		aspect-ratio: auto; /* 取消固定比例，避免图片变形 */
		height: auto; /* 高度自适应 */
		margin-top: 12px; /* 图片和文字间距 */
	}

	/* 可选：调整标题和段落的样式，适应小屏幕 */
	.news-content h4 {
		font-size: 1.25rem;
	}

	.news-content p {
		font-size: 0.9rem;
	}
}
</style>
